import { getPhotoError } from "./util";
import OkC from "shared/util/OkcApi";

/*
 * Upload a photo to the server.
 *
 * @param {string} url - The photo URL
 * @param {string} userid - The user's id
 */
export default function uploadPhotoURL(url, userid) {
	const data = {
		userid,
		url,
		okc_api: 1,
	};

	return new Promise((resolve, reject) => {
		const successFunction = (r = {}) => {
			const res = r.data || r;

			if (res.error || !Object.keys(res).length) {
				reject({ error: getPhotoError(res.error) });
				return;
			}

			resolve({
				picid: res.id,
				width: res.width,
				height: res.height,
				src: res.url,
			});
		};

		return OkC.legacy("/ajaxuploader", {
			type: "POST",
			data,
			success: successFunction,
			error: reject,
		});
	});
}



// WEBPACK FOOTER //
// ./src/shared/util/PhotoUpload/uploadPhotoURL.js